var isRTL = $('html').attr('dir') == 'rtl' ? true : false,
  winWidth = $(window).width(),
  winHeight = $(window).height(),
  topPos = 0,
  bottomPos = 0;
  isMobile = false;
var assetsURL = isRTL ? '..' : '.';
var bannerPrev = `<button class="icon-btn prev-btn js-left-icon-btn js-btn btn white">
<span class="btn-svg">
  <img src="${assetsURL}/assets/img/icons/small-arrow-left.svg" class="js-tosvg" alt="arrow-right" />
</span>
</button>
`;
var bannerNext = `<button class="icon-btn next-btn js-btn btn white">
<span class="btn-svg">
  <img src="${assetsURL}/assets/img/icons/small-arrow-right.svg" class="js-tosvg"  alt="arrow-right" />
</span>
</button>`;
var match_Media = gsap.matchMedia();
gsap.registerPlugin(ScrollTrigger);
$(function () {
  if (winWidth < 767) {
    isMobile = true
  }
  browserDetect();
});

$(window).resize(function(){
  winWidth = $(window).width();
  winHeight = $(window).height();
  if (winWidth < 767) {
    isMobile = true
  }
  initCustomScrollbar();
});

var isRTL = $('html').attr('dir') == 'rtl' ? true : false;

$(window).on('load', function () {

  // Do after Page ready
	domOnLoad();
	ChangeToSvg();
	initValidation('.js-form-validation');
	scrollTop();
	ourApproachSlider();
	animButton();
	isotopes();
	periodSpan();
	drawer()
	dataSrc();
	destroyCustomScrollbar()
	videoPlayerInit();
	clickVideoPopup();
	documentAccordion();
	initSelect2(".js-select2");
	multiSelect2('.js-multi-select2');
	setTimeout(function () {
		$('html').addClass('dom-ready');
    ChangeToSvg();
	}, 200);
	intAccordion();
  intlTelInputInit();
});

function domOnLoad() {
  document.querySelector('body').classList.add('loaded');
  gsapImageParallax('.js-parllaxImg-trigger');
  gsapTextParallax('.js-parllaxText-trigger');
}

//Beowser Detect
function browserDetect() {
  navigator.sayswho = (function () {
    var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join('').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  })();
  $('body').addClass(navigator.sayswho);
}
// Convert Px to vh
function vhToPx(params) {
  const windowHeight = $(window).height();
  const pxValue = (params * windowHeight) / 100;
  return pxValue;
}

//Parallax Image 
function gsapImageParallax(elem) {
  if($(elem).length){
    const $element = $(elem)
    const translateValueInVh = isMobile ? 5 : 15;
    // let startPoint = `center center`; // gsap trigger starts points
    let endPoint = `bottom 0% `; // gsap trigger ends points
    let scurbVlaue = 1.1;
    let isMarkers = false;
    $element.each(function () {
      var $animateTriggerElement = $(this)
      const $animelement = $animateTriggerElement.find('.js-parllaxImg')
      // const $animInnerBannerelement = $animateTriggerElement.find('.inner-banner')
      const translateY_ = vhToPx(translateValueInVh); // translate Y value in px
      const actualHeightEleWrapper = $animelement.height(); // here we set the height of fixed img wrapper
      $animelement.height(actualHeightEleWrapper + translateY_);
      const parallaxImgTl = gsap.timeline({
        scrollTrigger: {
          trigger: $animateTriggerElement,
          start: `${actualHeightEleWrapper/2}px ${actualHeightEleWrapper/2}px`,
          end: endPoint,
          scrub: scurbVlaue,
          markers: isMarkers,
        },
      });
      parallaxImgTl.fromTo(
        $animelement,
        {
          y: 0,
        },
        {
          y: `-${translateY_}px`,
        }
      );
      
    })
  }
}
// Text Parallax Top Animate
function gsapTextParallax(elem) {
  if($(elem).length){
    const $element = $(elem)
    const translateValueInVh = 10;
    // let startPoint = `top center`; 
    let endPoint = `bottom 0% `;
    let scurbVlaue = 1;
    let isMarkers = false;
    $element.each(function () {
      var $animateTriggerElement = $(this)
      const translateY_ = vhToPx(translateValueInVh);
      const actualHeightEleWrapper = $animateTriggerElement.offset()
      const parallaxTopTl = gsap.timeline({
        scrollTrigger: {
          trigger:  $animateTriggerElement,
          // start: startPoint,
          start: `top ${actualHeightEleWrapper.top}px`,
          end: endPoint,
          scrub: scurbVlaue,
          markers: isMarkers,
        },
      });
      parallaxTopTl.fromTo(
        $animateTriggerElement,
        {
          y: 0,
        },
        {
          y: `-${translateY_}px`,
        }
      );
    });
  }
}

// Change Image to Svg
function ChangeToSvg() {
  $('img.js-tosvg').each(function () {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');
    $.get(
      imgURL,
      function (data) {
        var $svg = $(data).find('svg');
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' insvg');
        }
        $svg = $svg.removeAttr('xmlns:a');
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
        }
        $img.replaceWith($svg);
      },
      'xml'
    );
  });
}
// set isRTL based on HTML dir attribute
var isRTL = $('html').attr('dir') == 'rtl' ? true : false;

$.validator.addMethod('validEmail', value => /^([A-Za-z0-9_\-\.\%\$\&\'\(\)\*\+/])+\@([A-Za-z0-9_\-\.\%\$\&\'\(\)\*\+/])+\.([a-z]{2,4})$/gi.test(value));

$.validator.addMethod('validName', value => /^[a-zA-Z\s]+$/.test(value));
$.validator.addMethod('atLeastOneChecked', function(value, element) {
  var groupName = element.name.split('_')[0]; // Extract the group name from the checkbox name
  return $('input[name^="' + groupName + '"]:checked').length > 0;
}, 'Please select at least one option in each group.');

// Form Validation
function validateForm($target) {
  const selects2 = $target.find('select');
  const inputsText = $target.find('input[type="text"]');
  const inputsEmail = $target.find('input[type="email"]');
  const inputsCheckbox= $target.find('input[type="checkbox"]');
  const inputsCheckboxChecked= $target.find('input[type="checkbox"]:checked');
  const textareas = $target.find('textarea');
  let isValid = true;

    if(inputsCheckbox){
    inputsCheckbox.each((_, checkbox) => {
      if (inputsCheckboxChecked.length === 0) {
        isValid = false;
      }
    });
  }


  if(inputsText){
    inputsText.each((_, input) => {
      if (input.value === '') {
        isValid = false;
      }
    });
  }

  if(inputsEmail){
    inputsEmail.each((_, input) => {
      if (input.value === '') {
        isValid = false;
      }
    });
  }

  if(textareas){
    textareas.each((_, textarea) => {
      if (textarea.value === '') {
        isValid = false;
      }
    });
  }

  if(selects2){
      if (selects2.val() === '') {
        isValid = false;
      }
  }

  if (isValid) {
    return true;
  } else {
    return false;
  }
}

function multiSelect2(params) {
  if ($(params).length) {
    const $elements = $(params);

    $elements.each(function () {
      const $element = $(this);
      const placeholderAttr = $element.attr('data-placeholder');
      const otherOptionTitltAttr = $element.attr('data-other-option-title');
      const optionSeparatorAttr = $element.attr('data-option-separator');
      const dropdownContainerClassAttr = $element.attr('data-dropdown-container-class');
      const showClearButtonAttr = $element.attr('data-show-clear-button') === 'true';
      const clearButtonTitleAttr = $element.attr('data-clear-button-title');
      
      $element.select2({
        placeholder: placeholderAttr,
        closeOnSelect: false,
        dropdownCssClass: dropdownContainerClassAttr,
      });

      $element.on('select2:opening', function (event) {
        var $searchfield = $(this).parent().find('.select2-search__field');
        $searchfield.prop('disabled', true);
      });

      $element.on('select2:open', function () {
        if (clearButtonTitleAttr && showClearButtonAttr && !$('.select2-clear-all').length) {
          var $clearAllButton = $(`<button class="select2-clear-all">${clearButtonTitleAttr}</button>`);
          $clearAllButton.on('click', function () {
            $element.val(null).trigger('change');
            $element.select2('close');
            $element.select2('open');

            // If "Clear All" is clicked, show all items
            if( $('#isotopeContainer').length){
              $('#isotopeContainer').isotope({
                filter: '*'
              });
            }

          });
          $('.select2-dropdown').append($clearAllButton);
        }
      });

      $element.on('change', function (e) {
        // var selectedValues = $(this).val();
        // console.log(selectedValues, '--selectedValues');
        // var selectedCount = selectedValues ? selectedValues.length : 0;
        // if (selectedCount > 2) {
        //   var displayText = selectedValues.slice(0, 1).join('') + ` ${optionSeparatorAttr} ${selectedCount - 1} ${otherOptionTitltAttr}`;
        //   $element.next().find('.select2-selection__rendered').text(displayText);
        // } else {
        //   $element.next().find('.select2-selection__rendered').text(selectedValues.join(` ${optionSeparatorAttr} `));
        // }

         // Get the selected options
         var selectedOptions = $element.select2('data');
         var selectedCount = selectedOptions ? selectedOptions.length : 0;
         if (selectedCount > 2) {
           var displayText = selectedOptions.slice(0, 1).map(option => option.text).join('') +
                             ` ${optionSeparatorAttr} ${selectedCount - 1} ${otherOptionTitltAttr}`;
           $element.next().find('.select2-selection__rendered').text(displayText);
         } else {
           var selectedText = selectedOptions.map(option => option.text).join(` ${optionSeparatorAttr} `);
           $element.next().find('.select2-selection__rendered').text(selectedText);
         }
      });

    });
  }
}
function initValidation(target) {
  if ($(target).length) {
    var $target = $(target);
    $target.each(function (i, e) {
      const $elemValue = $(this) 
      var $submitButton = $elemValue.find('.js-btn');
      $submitButton.prop('disabled', true);
      
      var v = $target.eq(i).validate({
        errorElement: 'span',
        errorClass: 'error-txt body9',
        focusInvalid: false,
        highlight: function (element) {
          $(element).parents('.form-group').addClass('invalid-field');
        },
        unhighlight: function (element) {
          $(element).parents('.form-group').removeClass('invalid-field');
        },
        invalidHandler: function (form, validator, element) {
          var errors = validator.numberOfInvalids();
          if (errors) {
            $(element).parents('.form-group').addClass('invalid-field');
          } else {
            $target.find('.error-msg').hide();
          }
        },
        submitHandler: function (form, validator) {
          event.preventDefault();
          var formData = new FormData(form);

          var formDataObject = Object.fromEntries(formData.entries());

          formSubmit(formDataObject , form);
          // $elemValue.find('select').val('').trigger("change");
          // $(form).trigger('reset');
          $submitButton.prop('disabled', true);
        },
        errorPlacement: function (error, element) {
          if (element.attr('designation') === 'checkbox') {
            // Handle checkbox or intlTelInput error placement as needed
          } else {
            error.insertAfter(element);
          }
        },
      });
      $elemValue.find('input, textarea').on('keyup change blur', function () {
        if ($(this).valid() && validateForm($elemValue)) {
          $submitButton.prop('disabled', false);
        } else {
          $submitButton.prop('disabled', true);
        }
      });
      $elemValue.find('select').on('select2:closing', function () {
        if ($(this).valid()  && validateForm($elemValue)) {
          $submitButton.prop('disabled', false);
        } else {
          $submitButton.prop('disabled', true);
        }
      });
    });
  }
}

function scrollTop() {
  var lastScrollTop = 0;
  $(window).scroll(function () {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
      $('body').addClass('bodyScrolled');
      $('body').removeClass('scrollTop');
      $('body').removeClass('menuOpen');
      $('.menu-link').removeClass('active');
      $('.sub-menu .sub-list').removeClass('show--menu');
      $('.sub-menu').removeClass('show');
      $('.sub-menu .sub-menu-link').removeClass('active');
      $('.sub-menu .additional-menu').removeClass('show--menu');
      $('.subMenu-list').removeClass('show');
      $('.mega-menu-cover').height(0);
    } else {
      $('body').addClass('scrollTop');
      $('body').removeClass('bodyScrolled');
    }
    if (st === 0) {
      $('body').removeClass('scrollTop');
      $('body').removeClass('bodyScrolled');
    }

    lastScrollTop = st;
  });
}
$(document).ready(function () {
  $('.menuIcon').click(function () {
    $('body').toggleClass('menu--open');
    $('body').toggleClass('menuOpen');
    $('.menu-link').find('.active').removeClass('active');
    $('.menu-link').find('.active').removeClass('active');
    $('.menu-link').removeClass('active')
    $('.subMenu-list').slideUp();
    $('.subMenu-list-items').slideUp();
  });
  initTabsAccordion();
  initCustomScrollbar();
});

var assetsURL = isRTL ? '..' : '.';

// Animate Buttons
function animButton() {
  const buttons = $('.js-btn');

  buttons.each((i, btn) => {
    const isLeftIconBtn = $(btn).hasClass('js-left-icon-btn');

    $(btn).mouseenter(() => {
      if (!isRTL) {
        $(btn).toggleClass('anim-btn', !isLeftIconBtn);
        $(btn).toggleClass('reverse-anim-btn', isLeftIconBtn);
      } else {
        $(btn).toggleClass('anim-btn', isLeftIconBtn);
        $(btn).toggleClass('reverse-anim-btn', !isLeftIconBtn);
      }
    });

    $(btn).mouseleave(() => {
      if (!isRTL) {
        $(btn).toggleClass('anim-btn', isLeftIconBtn);
        $(btn).toggleClass('reverse-anim-btn', !isLeftIconBtn);
      } else {
        $(btn).toggleClass('anim-btn', !isLeftIconBtn);
        $(btn).toggleClass('reverse-anim-btn', isLeftIconBtn);
      }
    });
  });
}

// Our Approach Slider
function ourApproachSlider() {
  $('.our-approach-section-slider-left').on('init', function(event, slick){
    if (winWidth < 1200) {
      var sliderHeight = ($('.our-approach-section-slider-left').height() - 60 );
      $('.our-approach-section-slider-left .slider-item').height(sliderHeight)
    }
  });
  $('.our-approach-section-slider-left').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    swipe: false,
    draggable: false,
    rtl: isRTL,
    autoplay: false,
    infinite: true,
    speed: 500,
    asNavFor: '.our-approach-section-slider-right',
  });
  
  $('.our-approach-section-slider-right').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.our-approach-section-slider-left',
    dots: true,
    focusOnSelect: true,
    draggable: false,
    swipe: false,
    fade: false,
    rtl: isRTL,
    autoplay: false,
    speed: 500,
    nextArrow: bannerNext,
    prevArrow: bannerPrev,
    appendArrows: `.js-slide-arrow`,
    appendDots: '.js-dots',
    infinite: true,
  });
}

function periodSpan() {
  const periodSpans = $('.js-period-span');

  if (periodSpans.length > 0) {
    periodSpans.each((index, span) => {
      const $span = $(span);
      const innerHTML = $span.html();
      let updatedHTML = '';

      for (let i = 0; i < innerHTML.length; i++) {
        if (innerHTML[i] === '.') {
          updatedHTML += '<span class="colored-period">.</span>';
        } else {
          updatedHTML += innerHTML[i];
        }
      }

      $span.html(updatedHTML);
    });
  }
}

// initialize Isotopes
function isotopes() {
  var $isotopeContainer = $('.js-isotope-wrapper').isotope({
    itemSelector: '.employee-details',
    layoutMode: 'fitRows'
  });
  var filters = [];
    $('.filters').on('change', function(event) {
      var $select = $( event.target );
      var filterGroup = $select.attr('value-group');
      filters[filterGroup] = getSelectedValues($select);
      var filterValue = concatValues( filters );
      console.log(filterValue ,'--filterValue')
      $isotopeContainer.isotope({ filter: filterValue });
  });
}

function getSelectedValues($select) {
  var selectedValues = $select.val();
  return selectedValues || [];  
}

function concatValues(obj) {
  var values = [];
  var isCatTypeArray = false
  for (var prop in obj) {
    if (Array.isArray(obj[prop])) {      
      if(obj['designation'] != undefined && obj['designation'].length > 0 && obj['function'] != undefined && obj['function'].length > 0 && obj['commite'] != undefined && obj['commite'].length > 0){
        values = values.concat(generateThreeCombinations(obj['commite'], obj['function'], obj['designation']));
        isCatTypeArray = true
      }else if(obj['designation'] != undefined && obj['designation'].length > 0 && obj['function'] != undefined && obj['function'].length > 0){
        values = values.concat(generateCombinations(obj['function'], obj['designation']));
        isCatTypeArray = true
      }else if(obj['commite'] != undefined && obj['commite'].length > 0 && obj['function'] != undefined && obj['function'].length > 0){
        values = values.concat(generateCombinations(obj['function'], obj['commite']));
        isCatTypeArray = true
      }else if(obj['designation'] != undefined && obj['designation'].length > 0 && obj['commite'] != undefined && obj['commite'].length > 0){
        values = values.concat(generateCombinations(obj['commite'], obj['designation']));
        isCatTypeArray = true
      }
      else{
        values = values.concat(obj[prop]);
        isCatTypeArray = false
      }
    } else {
      isCatTypeArray = false
      values.push(`${obj[prop]}`);
    }
  }
  
  let uniqueArray = values.filter((value, index, self) => {
    return self.indexOf(value) === index;
  })
  return  isCatTypeArray ? uniqueArray.join(', ') : values.join(', ');
}

function generateCombinations(categories, types) {
  const combinations = [];
  categories.forEach(function (cat) {
      types.forEach(function (type) {
        combinations.push(`${cat}${type}`);
      });
  });
  
  return combinations;
}

function generateThreeCombinations(categories, types, commites) {
  const combinations = [];
  categories.forEach(function (cat) {
    types.forEach(function (type) {
      commites.forEach(function (commite) {
        combinations.push(`${cat}${type}${commite}`);
      });
    });
  });

  return combinations;
}


$(document).ready(function () {
  $('.js-accordion').on('click', function () {
    // Toggle active class for accordion
    $(this).toggleClass('active');

    // Toggle visibility of the associated more-info section
    var $employeeDetails = $(this).closest('.employee-details');
    $employeeDetails.find('.js-collapse').slideToggle(200, function () {
      // Trigger Isotope layout after the slideToggle animation is complete
      $('.js-isotope-wrapper').isotope('layout');
    });

    // Toggle active class for the clicked employee details
    $employeeDetails.toggleClass('active');

    // Remove "active" class from other accordions and employee details
    $('.js-accordion').not(this).removeClass('active');
    $('.js-collapse').not($employeeDetails.find('.js-collapse')).slideUp(200);
    $('.employee-details').not($employeeDetails).removeClass('active');
  });
});

function documentAccordion() {
  $('.js-accordion-document').on('click', function () {
    // Toggle active class for accordion
    $(this).toggleClass('active');

    var $employeeDetails = $(this).closest('.accordion-item');
    $employeeDetails.find('.js-collapse').slideToggle(500, function () {});

    // Toggle active class for the clicked accordion item
    $employeeDetails.toggleClass('active');

    // Remove "active" class from other accordion items
    $('.js-accordion-document').not(this).removeClass('active');
    $('.js-collapse').not($employeeDetails.find('.js-collapse')).slideUp(200);
    $('.accordion-item').not($employeeDetails).removeClass('active');
  });

  // Trigger click on the first accordion item
  $('.js-accordion-document:first').click();
}

$('.js-accordion-document-2').on('click', function () {
  // Toggle active class for accordion
  $(this).toggleClass('active');
  // Toggle visibility of the associated more-info section with animation
  var $employeeDetails = $(this).closest('.accordion-item');
  $employeeDetails.find('.js-collapse').slideToggle(200, function () {
    // Check if the accordion is now open
    if ($employeeDetails.hasClass('active')) {
      // Animate image when opening accordion
      $employeeDetails.find('.image-box').animate(
        {
          opacity: 1,
        },
        200
      );
    } else {
      // Animate image when closing accordion
      $employeeDetails.find('.image-box').animate(
        {
          opacity: 0,
        },
        200
      );
    }
  });
  // Toggle active class for the clicked accordion item
  $employeeDetails.toggleClass('active');
  // Remove "active" class from other accordion items
  $('.js-accordion-document-2').not(this).removeClass('active');
  $('.js-collapse').not($employeeDetails.find('.js-collapse')).slideUp(200);
  $('.accordion-item').not($employeeDetails).removeClass('active');
});

function dataSrc() {
  if (winWidth < 768) {
    $('[data-mobile-src]').each(function () {
      var thisSrc = $(this).attr('data-mobile-src');
      $(this).attr('src', thisSrc);
    });
    $('[data-mobile-poster]').each(function () {
      var thisSrc = $(this).attr('data-mobile-poster');
      $(this).attr('poster', thisSrc);
    });
  } else {
    $('[data-desktop-src]').each(function () {
      var thisSrc = $(this).attr('data-desktop-src');
      $(this).attr('src', thisSrc);
    });
    $('[data-desktop-poster]').each(function () {
      var thisSrc = $(this).attr('data-desktop-poster');
      $(this).attr('poster', thisSrc);
    });
  }
}
function videoPlayerInit() {
  $('.my-video-js').each(function (index) {
    var thisId = $(this).attr('id');
    $(this).addClass('video-js');
    if (!thisId == '') {
      thisId = 'video-id-' + index;
      $(this).attr('id', thisId);
    }
    var player = videojs(thisId);
  });
}

$(document).on('click', '.play-btn-js', function () {
  $(this).hide();
  var video = $(this).siblings('.my-video-js').children('video').get(0);
  video.play();
});

if (winWidth > 768) {
  $('.header .header-wrapper .header-listing .sec--menu ul').mCustomScrollbar('destroy');
}

function initSelect2(target) {
  var target = $(target);
  target.each(function (i, e) {
    var tarPar = $(e).parent(".select2-box");
    var tarPlace = $(e).data("placeholder");
    var dataClass = $(e).data("class");
    $(e).select2({
      placeholder: tarPlace,
      minimumResultsForSearch: -1
    });
  });
}

$("#goto-contact").click(function() {
  $('html, body').animate({
      scrollTop: ($("#contactBar").offset().top - 100)
  }, 2000);
});

$('.tab-menu ul li a').on('click', function(){
  var target = $(this).attr('data-rel');
  $('.tab-menu ul li a').removeClass('active');
  $(this).addClass('active');
  $(".tab-box:visible").fadeOut(300, function() {
    $("#" + target).fadeIn(400);
  });
  if ($(window).width() <= 768) {
    var tabPosition = $(this).parent().position().left;
    var containerScroll = $('.tab-menu ul').scrollLeft();
    var scrollTo = tabPosition + containerScroll - 30;
    $('.tab-menu ul').animate({ scrollLeft: scrollTo }, 'slow');
  }
  if ($('.js-create-long-term').hasClass('sec-create-long-term')) {
    $('html, body').animate({
      scrollTop: ($(".etf-detail-wrapper").offset().top - 200)
    }, 400);
  } else {
    $('html, body').animate({
      scrollTop: ($(".etf-detail-wrapper").offset().top)
    }, 100);
  }
  return false;
});

$('.page--wrapper, .footer-section').on('click', function(){
  $('body').removeClass('menuOpen');
  $('.menu-link').removeClass('active');
  $('.sub-menu .sub-menu-link').removeClass('active');
  $('.additional-menu').removeClass('show--menu');
  $('.subMenu-list').removeClass('show');
  $('.lan-dr').removeClass('active');
  $('.lan-dr').parents('.lang-dropdown').removeClass("lang--switch");
  $('.mega-menu-cover').height(0)
});

// Press scape
$(document).keydown(function(event) {
  if (event.which === 27) {
    $('body').removeClass('menuOpen');
    $('body').removeClass('menu--open');
    $('.menu-link').removeClass('active');
    $('.sub-menu .sub-menu-link').removeClass('active');
    $('.additional-menu').removeClass('show--menu');
    $('.subMenu-list').removeClass('show');
    $('.mega-menu-cover').height(0);
  }
});

function clickVideoPopup() {
	$('body')
		.on('click', '.js-videoPopup', function () {
			videoPopup($(this));
		})
		.on('click touchstart', '.parent-cl', function (e) {
			$(this).parents('.video-box').toggleClass('play-video');
			var etarget = $(e.target);
			if (winWidth < 1300) {
				if (etarget.parents('.video-box').hasClass('play-video')) {
					etarget[0].play();
				} else {
					etarget[0].pause();
				}
			}
		});
}
function videoPopup(target) {
	var $target = $(target);
	var videoUrl;
	var vidPlayer = null;
	if (winWidth < 768) {
		videoUrl = $target.data('mobile-url');
	} else {
		videoUrl = $target.data('desktop-url');
	}
	var videoClass = $target.data('video-class');
	var videoWidth = $target.data('width');
	var videoHeight = $target.data('height');
	var videoType = $target.data('video-type');
	var videoPoster = $target.data('video-poster') || null;
	var techOrder = ['html5', 'youtube', 'wistia'];
	var $content =
		'<div class="popup-video op-0"><video id="lightboxVideo" width="' +
		videoWidth +
		'" height="' +
		videoHeight +
		'" preload="auto" controls autoplay class="video-js vjs-layout-large" data-setup="{}"><source src="' +
		videoUrl +
		'" type="video/mp4" /><p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="https://videojs.com/html5-video-support/" target="_blank" rel="noopener noreferrer">supports HTML5 video</a></p></video></div>';
	$.fancybox.open({
		type: 'html',
		content: $content,
		beforeShow: function () {
			$('body').addClass('is--videopopup');
			$('.fancybox-container').addClass(videoClass);
		},
		afterShow: function () {
			vidPlayer = videojs('lightboxVideo', function () {
				techOrder;
			});
			vidPlayer.src({
				type:
					videoType === 'youtube'
						? 'video/youtube'
						: videoType === 'wistia'
							? 'video/wistia'
							: 'video/mp4',
				src:
					videoType === 'youtube'
						? 'https://www.youtube.com/watch?v=' + videoUrl
						: videoType === 'wistia'
							? 'http://fast.wistia.com/embed/iframe/' + videoUrl
							: videoUrl,
			});
			if (videoPoster) vidPlayer.poster(videoPoster);
			vidPlayer.on('ready', function () {
				vidPlayer.play();
			});
			$('.popup-video').animate(
				{
					opacity: '1',
				},
				500
			);
		},
		beforeClose: function () {
			$('body').removeClass('is--videopopup');
			videojs('lightboxVideo').dispose();
		},
	});
}

// Section Animation
$(document).ready(function() {
  // Function to check if element is in viewport
  setTimeout(function() {
    if ($(window).scrollTop() === 0) {
      $('.header').addClass('header-animate');
    }
    $('.sec-banner .banner-wrapper .banner-content ').addClass('sec-animate');
    $(' .who-we-are-section .who-we-are-wrap .content-wrapper .content.sty-1, .who-we-are-section .who-we-are-wrap .bottom-info .info-wrapper .info-box, .sec-banner.inner-banner .banner-wrapper .banner-content.sty1, .sec-breadcrumb, .core-investment-section .core-investment-wrap .content-wrapper .content.sty-1, .core-investment-section .core-investment-wrap .accordion .accordion-item .accordion-header, .sec-banner.sty2, .sec-testimonial .testimonial-wrapper .post-box, .footer-section .footer-top .footer-top-left, .footer-section .footer-middle .footer-middle-left, .sec-banner .banner-wrapper .banner-content .bannerTitle-wrap, .our-approach-section .our-approach-section-top .our-approach-section-top-left, .our-approach-section .our-approach-section-slider .our-approach-section-bottom-flex, .news-section .news-wrap .info-wrapper .content.sty-1, .news-section .news-wrap .bottom-sec .tabs-wrapper .tabs, .strategy-section .strategy-section-wrap .content-wrapper .content.sty-1, .strategy-section .strategy-section-wrap .cards-wrapper .card, .sec-climat-economy .post-box .post-content, .sec-news-detail .news-detail-wrapper .sec-bg img, .sec-news-detail .news-detail-wrapper .publish-date, .sec-news-detail .news-detail-wrapper .detail-box .news-title, .sec-news-detail .news-detail-wrapper .detail-box .heading6, .sec-news-detail .news-detail-wrapper .detail-box p, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content .heading6, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content ul li, .sec-news-detail .news-detail-wrapper .detail-box .video-box, .sec-related-news .sec-title, .sec-related-news .related-news-wrapper .postBox, .sec-news-detail .news-detail-wrapper .detail-box ul.invest li, .meet-the-team-section .meet-the-team-wrap .content-wrapper .content.sty-1, .life-at-lunate-section .strategy-section-wrap .image-wrap, .sec-content-page .content-page-wrapper .heading6, .sec-content-page .content-page-wrapper a, .sec-content-page .content-page-wrapper p, .sec-content-page .content-page-wrapper .content-box.sty2 ul li, .sec-content-page .content-page-wrapper .content-box ul li, .meet-the-team-section .meet-the-team-wrap .teams-wrapper .employee-details, .lunate-team-section .lunate-team-wrap .content-wrapper.content-wrapper--modifer .content.content-title, .etfs-intro-section .etfs-intro-wrap .content-wrapper .content.sty-1').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate');
      }
    });
    $('.sec-news-detail .news-detail-wrapper .main-heading').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate');
      }
    });
    $('.sec-contact-us .meet-the-team-wrap .contact-title , .who-we-are-section').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate2');
      }
    });
    $('.etfs-intro-section .etfs-intro-wrap .table-section .tabs-blocks-wrapper .tabs-container, .etfs-intro-section .etfs-intro-wrap .table-section .table-shadow, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-title .heading3, .sec-etf-detail .etf-detail-wrapper .detail-box .value-boxes, .sec-etf-detail .etf-detail-wrapper .detail-box .about-fund .sec-title, .sec-etf-detail .etf-detail-wrapper .detail-box .detail--boxes .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-chart-boxes .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-title .heading3, .sec-etf-detail .etf-detail-wrapper .detail-box .sec-graph .postBox .heading6, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box, .sec-etf-detail .etf-detail-wrapper .detail-box .sec-graph .postBox .heading6, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .box-content, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .box-content .box-title, .sec-etf-detail .etf-detail-wrapper .detail-box .box-chart .box-wrapper .chart-info, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box li.title, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box p.title, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box ul li, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes.sty1 .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .accordion .accordion-item, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .provider-wrapper .heading6, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .provider-boxes-wrapper .postBox, .sec-thankyou .back-btn, .sec-thankyou .sec-thankyou-wrapper, .page--sec-title-generic, .meet-section .sec-detail .detail-content').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate');
      }
    });
    $('.strategy-section .strategy-section-wrap .head-para , .who-we-are-section .who-we-are-wrap .content-wrapper .content, .who-we-are-section .who-we-are-wrap .bottom-info .info-wrapper .info-box:nth-child(2), .core-investment-section .core-investment-wrap .content-wrapper .content, .sec-testimonial .testimonial-wrapper .post-box:nth-child(2), .footer-section .footer-top .footer-top-middle, .footer-section .footer-middle .footer-middle-right, .sec-banner .banner-wrapper .banner-content .banner-para, .our-approach-section-top-right, .news-section .news-wrap .info-wrapper .content, .news-section .news-wrap .bottom-sec .tabs-wrapper .tabs .box.sty-1, .strategy-section .strategy-section-wrap .content-wrapper .content, .strategy-section .strategy-section-wrap .cards-wrapper .card:nth-child(2), .sec-climat-economy .post-box .post-img, .sec-related-news .related-news-wrapper .postBox:nth-child(2), .meet-the-team-section .meet-the-team-wrap .content-wrapper .content, .meet-the-team-section .meet-the-team-wrap .teams-wrapper .employee-details:nth-child(2), .lunate-team-section .lunate-team-wrap .content-wrapper.content-wrapper--modifer .content, .etfs-intro-section .etfs-intro-wrap .content-wrapper .content, .filter-items-wrapper, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-title .video-box, .sec-etf-detail .etf-detail-wrapper .detail-box .about-fund .sec-detail, .sec-etf-detail .etf-detail-wrapper .detail-box .detail--boxes .postBox:nth-child(2), .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes .postBox:nth-child(2), .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes.sty1 .postBox:nth-child(2), .meet-section .sec-detail .team-details').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate2');
      }
    });
    $('.who-we-are-section .who-we-are-wrap .bottom-info .info-wrapper .info-box:nth-child(3), .footer-section .footer-top .footer-top-right, .strategy-section .strategy-section-wrap .cards-wrapper .card:nth-child(3), .meet-the-team-section .meet-the-team-wrap .teams-wrapper .employee-details:nth-child(3),  .sec-etf-detail .etf-detail-wrapper .detail-box .detail--boxes .postBox:nth-child(3), .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes.sty1 .postBox:nth-child(3)').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate3');
      }
    });
    $('.strategy-section .strategy-section-wrap .cards-wrapper .card:nth-child(4)').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate4');
      }
    });
  }, 1000);
  function isElementInViewport(elem) {
    var $elem = $(elem);
    var docViewTop = $(window).scrollTop() - 20;
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();
    return elemBottom >= docViewTop && elemTop <= docViewBottom;
  }
  // Add class when element is in viewport
  $(window).scroll(function() {
    $('.who-we-are-section .who-we-are-wrap .content-wrapper .content.sty-1, .who-we-are-section .who-we-are-wrap .bottom-info .info-wrapper .info-box, .sec-banner.inner-banner .banner-wrapper .banner-content.sty1, .sec-breadcrumb, .core-investment-section .core-investment-wrap .content-wrapper .content.sty-1, .core-investment-section .core-investment-wrap .accordion .accordion-item .accordion-header, .sec-banner.sty2, .sec-testimonial .testimonial-wrapper .post-box, .footer-section .footer-top .footer-top-left, .footer-section .footer-middle .footer-middle-left, .sec-banner .banner-wrapper .banner-content .bannerTitle-wrap, .our-approach-section .our-approach-section-top .our-approach-section-top-left, .our-approach-section .our-approach-section-slider .our-approach-section-bottom-flex, .news-section .news-wrap .info-wrapper .content.sty-1, .news-section .news-wrap .bottom-sec .tabs-wrapper .tabs, .strategy-section .strategy-section-wrap .content-wrapper .content.sty-1, .strategy-section .strategy-section-wrap .cards-wrapper .card, .sec-climat-economy .post-box .post-content, .sec-news-detail .news-detail-wrapper .sec-bg img, .sec-news-detail .news-detail-wrapper .publish-date, .sec-news-detail .news-detail-wrapper .detail-box .news-title, .sec-news-detail .news-detail-wrapper .detail-box .heading6, .sec-news-detail .news-detail-wrapper .detail-box p, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content .heading6, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content ul li, .sec-news-detail .news-detail-wrapper .detail-box .video-box, .sec-related-news .sec-title, .sec-related-news .related-news-wrapper .postBox, .sec-news-detail .news-detail-wrapper .detail-box ul.invest li, .meet-the-team-section .meet-the-team-wrap .content-wrapper .content.sty-1, .life-at-lunate-section .strategy-section-wrap .image-wrap, .sec-content-page .content-page-wrapper .heading6, .sec-content-page .content-page-wrapper a, .sec-content-page .content-page-wrapper p, .sec-content-page .content-page-wrapper .content-box.sty2 ul li, .sec-content-page .content-page-wrapper .content-box ul li, .meet-the-team-section .meet-the-team-wrap .teams-wrapper .employee-details, .lunate-team-section .lunate-team-wrap .content-wrapper.content-wrapper--modifer .content.content-title, .etfs-intro-section .etfs-intro-wrap .content-wrapper .content.sty-1').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate');
      }
    });
  });
  $(window).scroll(function() {
    $('.who-we-are-section .who-we-are-wrap .content-wrapper .content.sty-1, .who-we-are-section .who-we-are-wrap .bottom-info .info-wrapper .info-box, .sec-banner.inner-banner .banner-wrapper .banner-content.sty1, .sec-breadcrumb, .core-investment-section .core-investment-wrap .content-wrapper .content.sty-1, .core-investment-section .core-investment-wrap .accordion .accordion-item .accordion-header, .sec-banner.sty2, .sec-testimonial .testimonial-wrapper .post-box, .footer-section .footer-top .footer-top-left, .footer-section .footer-middle .footer-middle-left, .sec-banner .banner-wrapper .banner-content .bannerTitle-wrap, .our-approach-section .our-approach-section-top .our-approach-section-top-left, .our-approach-section .our-approach-section-slider .our-approach-section-bottom-flex, .news-section .news-wrap .info-wrapper .content.sty-1, .news-section .news-wrap .bottom-sec .tabs-wrapper .tabs, .strategy-section .strategy-section-wrap .content-wrapper .content.sty-1, .strategy-section .strategy-section-wrap .cards-wrapper .card, .sec-climat-economy .post-box .post-content, .sec-news-detail .news-detail-wrapper .sec-bg img, .sec-news-detail .news-detail-wrapper .publish-date, .sec-news-detail .news-detail-wrapper .detail-box .news-title, .sec-news-detail .news-detail-wrapper .detail-box .heading6, .sec-news-detail .news-detail-wrapper .detail-box p, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content .heading6, .sec-news-detail .news-detail-wrapper .detail-box .table-of-content ul li, .sec-news-detail .news-detail-wrapper .detail-box .video-box, .sec-related-news .sec-title, .sec-related-news .related-news-wrapper .postBox, .sec-news-detail .news-detail-wrapper .detail-box ul.invest li, .meet-the-team-section .meet-the-team-wrap .content-wrapper .content.sty-1, .life-at-lunate-section .strategy-section-wrap .image-wrap, .sec-content-page .content-page-wrapper .heading6, .sec-content-page .content-page-wrapper a, .sec-content-page .content-page-wrapper p, .sec-content-page .content-page-wrapper .content-box.sty2 ul li, .sec-content-page .content-page-wrapper .content-box ul li, .meet-the-team-section .meet-the-team-wrap .teams-wrapper .employee-details, .lunate-team-section .lunate-team-wrap .content-wrapper.content-wrapper--modifer .content.content-title, .etfs-intro-section .etfs-intro-wrap .content-wrapper .content.sty-1').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate');
      }
    });
  });
  $(window).scroll(function() {
    $('.etfs-intro-section .etfs-intro-wrap .table-section .tabs-blocks-wrapper .tabs-container, .etfs-intro-section .etfs-intro-wrap .table-section .table-shadow, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-title .heading3, .sec-etf-detail .etf-detail-wrapper .detail-box .value-boxes, .sec-etf-detail .etf-detail-wrapper .detail-box .about-fund .sec-title, .sec-etf-detail .etf-detail-wrapper .detail-box .detail--boxes .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-chart-boxes .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-title .heading3, .sec-etf-detail .etf-detail-wrapper .detail-box .sec-graph .postBox .heading6, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box, .sec-etf-detail .etf-detail-wrapper .detail-box .sec-graph .postBox .heading6, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .box-content, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .box-content .box-title, .sec-etf-detail .etf-detail-wrapper .detail-box .box-chart .box-wrapper .chart-info, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box li.title, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box p.title, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box ul li, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes.sty1 .postBox, .sec-etf-detail .etf-detail-wrapper .detail-box .accordion .accordion-item, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .provider-wrapper .heading6, .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .provider-boxes-wrapper .postBox, .sec-thankyou .back-btn, .sec-thankyou .sec-thankyou-wrapper, .page--sec-title-generic, .meet-section .sec-detail .detail-content , .sec-content-page .content-page-wrapper .content-inner , .who-we-are-section .who-we-are-wrap .head-para , .our-approach-section .sub-heading , .news-section .head-para  , .sec-news-detail .news-detail-wrapper .main-heading').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate');
      }
    });
  });
  $(window).scroll(function() {
    $(' .strategy-section .strategy-section-wrap .head-para , .who-we-are-section .who-we-are-wrap .content-wrapper .content, .who-we-are-section .who-we-are-wrap .bottom-info .info-wrapper .info-box:nth-child(2), .core-investment-section .core-investment-wrap .content-wrapper .content, .sec-testimonial .testimonial-wrapper .post-box:nth-child(2), .footer-section .footer-top .footer-top-middle, .footer-section .footer-middle .footer-middle-right, .sec-banner .banner-wrapper .banner-content .banner-para, .our-approach-section-top-right, .news-section .news-wrap .info-wrapper .content, .news-section .news-wrap .bottom-sec .tabs-wrapper .tabs .box.sty-1, .strategy-section .strategy-section-wrap .content-wrapper .content, .strategy-section .strategy-section-wrap .cards-wrapper .card:nth-child(2), .sec-climat-economy .post-box .post-img, .sec-related-news .related-news-wrapper .postBox:nth-child(2), .meet-the-team-section .meet-the-team-wrap .content-wrapper .content, .meet-the-team-section .meet-the-team-wrap .teams-wrapper .employee-details:nth-child(2), .lunate-team-section .lunate-team-wrap .content-wrapper.content-wrapper--modifer .content, .etfs-intro-section .etfs-intro-wrap .content-wrapper .content, .filter-items-wrapper, .sec-etf-detail .etf-detail-wrapper .detail-box .detail-title .video-box, .sec-etf-detail .etf-detail-wrapper .detail-box .about-fund .sec-detail, .sec-etf-detail .etf-detail-wrapper .detail-box .detail--boxes .postBox:nth-child(2), .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes .postBox:nth-child(2), .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes.sty1 .postBox:nth-child(2), .meet-section .sec-detail .team-details , .sec-contact-us .meet-the-team-wrap .contact-title , .sec-etf-detail.sec-create-long-term , .who-we-are-section').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate2');
      }
    });
  });
  $(window).scroll(function() {
    $('.who-we-are-section .who-we-are-wrap .bottom-info .info-wrapper .info-box:nth-child(3), .footer-section .footer-top .footer-top-right, .strategy-section .strategy-section-wrap .cards-wrapper .card:nth-child(3), .meet-the-team-section .meet-the-team-wrap .teams-wrapper .employee-details:nth-child(3),  .sec-etf-detail .etf-detail-wrapper .detail-box .detail--boxes .postBox:nth-child(3), .sec-etf-detail .etf-detail-wrapper .detail-box .tab--detail-box .content-box .description-boxes.sty1 .postBox:nth-child(3)  ').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate3');
      }
    });
  });
  $(window).scroll(function() {
    $('.strategy-section .strategy-section-wrap .cards-wrapper .card:nth-child(4)').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('sec-animate4');
      }
    });
  });
  $(window).scroll(function() {
    $('.header').each(function() {
      if (isElementInViewport(this)) {
        $(this).addClass('header-animate');
      }
    });
  });
});
// Cookie Banner
$(document).ready(function () {
	var banner = $('.js-cookie-banner-wrap');
	var acceptButton = $('.js-cookie-understand');
	if (localStorage.getItem('cookieAccepted')) {
		banner.hide();
	} else {
		banner.show();
  }
	acceptButton.on('click', function () {
		banner.slideUp(300);
    console.log("cookieAccepted")
		localStorage.setItem('cookieAccepted', 'true');
	});
});

// Custom Drawer
function drawer() {
  const $jsDrawers = $(".js-drawer");
  const $jsDrawersClose = $(".js-drawer-close");
  const $jsBody = $("body");
  const $jsSliderElem = $(".js-slider-drawer-wrapper");
  if ($jsDrawers.length) {
    $jsDrawers.click(function () {
      const drawerId = $(this).data("drawer-id");
      const parentElem = $(this).closest(".slick-slide");
      if (parentElem.length) {
        const slideIndex = parentElem.attr("data-slick-index");
        goToSlide($jsSliderElem, slideIndex);
      }
      $(`[data-drawer-id="${drawerId}"]`).each(function () {
        const element = $(this);
        if (element.hasClass("js-drawer-wrapper")) {
          element.addClass("popup--show");
        }
      });
      $jsBody.addClass("overflow-y-hidden");
    });
    $jsDrawersClose.click(function () {
      const drawerId = $(this).data("drawer-id");
      $(`[data-drawer-id="${drawerId}"]`).removeClass("popup--show");
      if (!$(".popup--show")[0]) {
        $jsBody.removeClass("overflow-y-hidden");
      }
      $(".drawer-content").mCustomScrollbar("scrollTo", "top");
      
    });
    $jsBody.on("click", function (event) {
      const isDrawerOpenBtn = $(event.target).closest(".js-drawer").length > 0;
      const isDrawerConatainer =
        $(event.target).closest(".drawer-contentBox").length > 0;
      if (!isDrawerOpenBtn && !isDrawerConatainer) {
        $(".js-drawer-wrapper").removeClass("popup--show");
        $jsBody.removeClass("overflow-y-hidden");
      }
    });
    ChangeToSvg();
  }
}

function destroyCustomScrollbar() {
  if ($(window).width() < 768) {
    $('.drawer-content').mCustomScrollbar('destroy');
  } else{
    $('.drawer-content').mCustomScrollbar();
  }
}

$('#scroll-to-banner').on('click', function() {
  var bannerWrapperHeight = $('.banner-wrapper').height();
  $('html, body').animate({
      scrollTop: bannerWrapperHeight
  }, 1500);
});

$(document).ready(function(){
  setTimeout(function() { 
    if(window.winWidth < 768){
      $(".side-bar-wrapper ul li a svg").hide();
    }
  }, 1000);
});

//close header
$(document).ready(function(){
  $('.page--wrapper , .footer-section').hover(
    function(){
      $('body').removeClass('menuOpen');
      $('.menu-link').removeClass('active');
      $('.subMenu-list').removeClass('show');
      $('.header').removeClass('header--large');
      $('.lan-dr').removeClass('active');
      $('.lan-dr').parents('.lang-dropdown').removeClass("lang--switch");
      $('.mega-menu-cover').height(0);
    },   
  );
});
// menu
var megamenuHoveredheight;
$(document).ready(function () {
  if (winWidth >= 1200) {
    $('.main-menu .menu-link').on('mouseenter', function (e) {
      $('.main-menu .menu-link').not(this).removeClass('active');
      $('body').addClass('menuOpen');      
      $('.header').removeClass('noLinks');
      $('.subMenu-list').removeClass('show');
      $('.lan-dr').removeClass('active');
      $('.lan-dr').parents('.lang-dropdown').removeClass("lang--switch");
      var subMenuIndex = $(this).index();
      $('.main-menu .menu-link .subMenu-list').eq(subMenuIndex).addClass('show');
      if(!$(this).hasClass('active')){
        // console.log("testing", $('.main-menu .menu-link .subMenu-list').eq(subMenuIndex).height());
        $('.mega-menu-cover').height($('.main-menu .menu-link .subMenu-list').eq(subMenuIndex).height())
      }
      megamenuHoveredheight = $('.main-menu .menu-link .subMenu-list').eq(subMenuIndex).height()
      $(this).addClass('active');
    });
    $('.main-menu .menu-link').on('mouseleave', function () {
      // console.log('ok')
    });
    $('.main-menu .menu-link .subMenu-list .menu--item').on('mouseenter', function () {
      // Remove 'show' class from all subMenu-lists
      $('.main-menu .menu-link .subMenu-list-items').removeClass('show--subMenu');
      // Assuming each menu-link has a corresponding subMenu-list with the same index or a data attribute
      var subMenuIndex1 = $(this).index();
      // console.log("testing2", $(this).find('.subMenu-list-items').height())
      if (megamenuHoveredheight <= $(this).find('.subMenu-list-items').height()) {
        $('.mega-menu-cover').height($(this).find('.subMenu-list-items').height())
      }
      $(this).find('.subMenu-list-items').addClass('show--subMenu');
    });
    $('.main-menu .menu-link-noLink').on('mouseenter', function () {
      $('.subMenu-list').removeClass('show');
      $('.main-menu .menu-link').removeClass('active');
      $('.main-menu .menu-link .subMenu-list-items').removeClass('show--subMenu');
      $('.header').addClass('noLinks');
      $('body').removeClass('menuOpen');
      $('.lan-dr').removeClass('active');
      $('.lan-dr').parents('.lang-dropdown').removeClass("lang--switch");
      $('.mega-menu-cover').height(0)
    })
    $('.menu-close').click(function () {
      $('body').removeClass('menuOpen');
      $('.menu-link').removeClass('active');
      $('.subMenu-list').removeClass('show');
      $('.mega-menu-cover').height(0)
    });
    
    $('.main-menu .menu-link .subMenu-list .menu--item').on('mouseleave', function () {
      $('.main-menu .menu-link .subMenu-list-items').removeClass('show--subMenu');
      $('.mega-menu-cover').height($(this).parents('.menu-link').find('.subMenu-list').height())
    });
  }
});
if (winWidth < 1200) {
  $(document).ready(function () {  
    $('.main-menu .menu-link > .main_item').on('click', function () {
      if(!$(this).parent().hasClass('active')) {
        $('.main-menu .menu-link').removeClass('active');
        $('.subMenu-list').slideUp();
        $('body').addClass('menuOpen');
        $(this).parent().addClass('active');
        $(this).parent('.menu-link').find('.subMenu-list').slideDown();
      } else {
        $('.main-menu .menu-link').removeClass('active');
        $('.subMenu-list').slideUp();
        $('body').removeClass('menuOpen');
      }
    });
    $('.subMenu-list .menu--item > .cta').on('click', function () {
      if(!$(this).hasClass('active')) {
        $('.subMenu-list .menu--item > .cta').removeClass('active')
        $('.subMenu-list-items').slideUp();
        $(this).addClass('active')
        $(this).parent('.menu--item').find('.subMenu-list-items').slideDown();
      } else {
        $('.subMenu-list .menu--item > .cta').removeClass('active')
        $('.subMenu-list-items').slideUp();
      }
    });



    $('.main-menu .menu-link-noLink').on('click', function () {
      $('.main-menu .menu-link').removeClass('active');
      $('.subMenu-list').slideUp();
    });
    $('.menu-close').click(function () {
      $('body').removeClass('menuOpen');
      $('.menu-link').removeClass('active');
      $('.subMenu-list').slideUp();
    });
  
    $('.subMenu-list li').hover(
      function () {
        $(this).children('ul.subMenu-list-items').addClass('show--subMenu');
      },
      function () {
        $(this).children('ul.subMenu-list-items').removeClass('show--subMenu');
      }
    );
  });
}
// Language dropdown
$(document).ready(function() {
  if (winWidth > 1199) {
    $('.js-lang-dropdown').on('mouseenter', function() {
        $('.subMenu-list').removeClass('show');
        $('.main-menu .menu-link').removeClass('active');
        $('.main-menu .menu-link .subMenu-list-items').removeClass('show--subMenu');
        $('.header').addClass('noLinks');
        $('body').removeClass('menuOpen');
        $('.lan-dr').addClass('active');
        $('.lan-dr').parents('.lang-dropdown').addClass("lang--switch");
        $('.mega-menu-cover').height(0)
    });
  } else {
    $('.js-lang-dropdown').on('click', function() {
      if (!$('.js-lang-dropdown').hasClass('lang--switch')) {
        $('.subMenu-list').removeClass('show');
        $('.main-menu .menu-link').removeClass('active');
        $('.main-menu .menu-link .subMenu-list-items').removeClass('show--subMenu');
        $('.header').addClass('noLinks');
        $('body').removeClass('menuOpen');
        $('.lan-dr').addClass('active');
        $('.lan-dr').parents('.lang-dropdown').addClass("lang--switch");
        $('.mega-menu-cover').height(0)
      } else {
        $('.lan-dr').removeClass('active');
        $('.lan-dr').parents('.lang-dropdown').removeClass("lang--switch");
      }
    });
  }
  $( "body" ).on( "mouseleave", function() {
    $('.menu-close').trigger('click');
  });
});
$("body").on("click", function(e) {
  if(!$(e.target).is(".js-lang-dropdown, .js-lang-dropdown *")) {
    $('.lan-dr').removeClass('active');
    $('.lan-dr').parents('.lang-dropdown').removeClass("lang--switch");
  }
});

// Accordion

//BEGIN
// function intAccordion(){
// 	$(".ac-title").on("click", function(e) {
// 		e.preventDefault();
// 		var $this = $(this);
// 		if (!$this.hasClass("ac-active")) {
// 			$(".ac-content").slideUp(400);
// 			$(".ac-title").removeClass("ac-active");
// 			$('.ac-arrow').removeClass('accordion__rotate');
//       var dataIndex = $(this).attr('data-index');
// 		}
// 		$this.toggleClass("ac-active");
// 		$this.next().slideToggle();
// 		$('.ac-arrow',this).toggleClass('accordion__rotate');
// 	});
// }

function intAccordion(){
  $(".ac-title").on("click", function(e) {
    e.preventDefault();
    var $this = $(this);
    var dataIndex = $(this).attr('data-index'); // Get the data-index attribute
    
    if (!$this.hasClass("ac-active")) {
      $(this).parent().parent().parent().find(".image-box .ac-image").removeClass('show');
      $(this).parent().parent().find(".ac-content").slideUp(400);
      $(this).parent().parent().find(".ac-title").removeClass("ac-active");
      $(this).parent().parent().find('.ac-arrow').removeClass('ac-icon-active');   

    // Add index-based class to the respective image-box item
      $(this).parent().parent().parent().find(".image-box .ac-image").eq(dataIndex).addClass('show');
      $this.addClass("ac-active");
      $this.next().slideDown();
      $('.ac-arrow', this).addClass('ac-icon-active');
    }
  });
}
function intlTelInputInit() {
  const input = document.querySelectorAll(".phone-number-input");
  if (input && input.length > 0) {
    input.forEach((input) => {
      var iti = window.intlTelInput(input, {
        separateDialCode: true,
        initialCountry: "ae",
      });
      window.iti = iti;
    });
  }
}

//END

// Tabs with Prev / Next functionality

function initTabsAccordion(){
  let visibleTabs = 5;
  let currentIndex = 0;
  const tabs = $('.tab-list .tab-list-item');
  const totalTabs = tabs.length;

  // Show only the first 5 tabs initially
  tabs.hide().slice(0, visibleTabs).show();

  // Handle tab click
  tabs.on('click', function() {
    const tabId = $(this).data('tab');
    activateTab($(this));
  });

  // Handle next button click
  $('#nextBtn').on('click', function() {
    if (currentIndex + visibleTabs < totalTabs) {
      currentIndex++;
      tabs.hide().slice(currentIndex, currentIndex + visibleTabs).show();
    }

    // Activate the next tab
    const nextTab = $('.tab-list-item.active').next('.tab-list-item');
    if (nextTab.length) {
      activateTab(nextTab);
    }
  });

  // Handle previous button click
  $('#prevBtn').on('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
      tabs.hide().slice(currentIndex, currentIndex + visibleTabs).show();
    }
    // Activate the previous tab
    const prevTab = $('.tab-list-item.active').prev('.tab-list-item');
    if (prevTab.length) {
      activateTab(prevTab);
    }
  });

  // Activate the first tab on load
  activateTab($('.tab-list-item:first'));

  // Function to activate a tab and show corresponding content
  function activateTab(tab) {
    const tabId = tab.data('tab');
    $('.tab-list-item').removeClass('active');
    tab.addClass('active');
    $('.content').removeClass('active');
    $('.content[data-tab="' + tabId + '"]').addClass('active');
  }
}
// End

// Faq Accordion

$(".faq-title").on("click", function(e) {
  e.preventDefault();
  var $this = $(this);
  if (!$this.hasClass("faq-active")) {
    $(".faq-content").slideUp(400);
    $(".faq-title").removeClass("faq-active");
    $('.faq-arrow').removeClass('faq-arrow-active');
  }
  $this.toggleClass("faq-active");
  $this.next().slideToggle();
  $('.faq-arrow',this).toggleClass('faq-arrow-active');
});

function initCustomScrollbar() {
  var windowWidth = $(window).width();
  
  if (windowWidth > 768) { // Desktop and larger screens
      $(".tab-list").mCustomScrollbar({
          axis: "x", // Horizontal scrollbar
          theme: "minimal"
      });
  } else {
      // Destroy the scrollbar on mobile devices
      $(".tab-list").mCustomScrollbar("destroy");
  }
}

$.validator.addMethod("validPhoneNumber", (value, element) => {
  // If the field is empty, pass validation
  if (value === "") {
    return true;
  }
  // Otherwise, perform the regex validation
  return /^\d{8,14}$/gi.test(value);
});